import { lazy } from 'react';

const AuditLockRequestorComponent = lazy(() =>
  import('../pages/AuditLock/RequestorAccess'),
);

const auditLockRequestorRoute = {
  auth: [
    {
      name: 'audit_lock_requestor',
      path: '/audit-lock/request',
      component: AuditLockRequestorComponent,
    },
  ],
};

export default auditLockRequestorRoute;
